module.exports = __webpack_public_path__ + "static/media/ai-pipelines-1.8e652528.png";